import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./styles.css";

document.documentElement.dataset.lenscoreRenderer = "booting";

function reportBootstrapError(errorLike) {
  const message = errorLike instanceof Error
    ? errorLike.message
    : String(errorLike?.message || errorLike || "Unknown renderer bootstrap error");
  if (window.parent !== window) {
    window.parent.postMessage({
      type: "log",
      level: "error",
      message: "renderer bootstrap failed",
      detail: { message },
    }, window.location.origin);
  }
}

window.addEventListener("error", (event) => reportBootstrapError(event.error || event.message));
window.addEventListener("unhandledrejection", (event) => reportBootstrapError(event.reason));

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
